module.exports = __webpack_public_path__ + "static/media/export-artwork.86854dac.png";